// @flow
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import React, { Fragment } from 'react'
import AccordionTitle from "../../../components/mui/app/accordionTitle/accordionTitle";
import Buttons from './partials/buttons'
import DataDisplay from './partials/dataDisplay'
import Inputs from './partials/inputs'
import Others from './partials/others'
import Table from './partials/table'
import Typographies from './partials/typographies'

type Props = {};

const MuiComponents = (props: Props) => {

	return (
		<Fragment>
			<Accordion>
				<AccordionSummary
					aria-controls="panel1-content"
					id="panel1-header"
				>
					<AccordionTitle
						title={'Typographies'}
					/>
				</AccordionSummary>
				<AccordionDetails>
					<Typographies/>
				</AccordionDetails>
			</Accordion>
			<Accordion>
				<AccordionSummary
					aria-controls="panel2-content"
					id="panel2-header"
				>
					<AccordionTitle
						title={'Buttons, IconButtons, LoadingButtons, Fabs'}
					/>
				</AccordionSummary>
				<AccordionDetails>
					<Buttons/>
				</AccordionDetails>
			</Accordion>
			<Accordion>
				<AccordionSummary
					aria-controls="panel3-content"
					id="panel3-header"
				>
					<AccordionTitle
						title={'AUTOCOMPLETE, CHECKBOX, RADIO GROUP, SELECT, RATING, SWITCH, SLIDER, TEXTFIELD, TOGGLE BUTTON, DATETIMEPICKERS'}
					/>
				</AccordionSummary>
				<AccordionDetails>
					<Inputs/>
				</AccordionDetails>
			</Accordion>
			<Accordion>
				<AccordionSummary
					aria-controls="panel4-content"
					id="panel4-header"
				>
					<AccordionTitle
						title={'TRANSFER LIST, AVATAR, BADGE, CHIP, DIVIDER, ICONS, LIST, TOOLTIP'}
					/>
				</AccordionSummary>
				<AccordionDetails>
					<DataDisplay/>
				</AccordionDetails>
			</Accordion>
			<Accordion>
				<AccordionSummary
					aria-controls="panel5-content"
					id="panel5-header"
				>
					<AccordionTitle
						title={'Table'}
					/>
				</AccordionSummary>
				<AccordionDetails>
					<Table/>
				</AccordionDetails>
			</Accordion>
			<Accordion>
				<AccordionSummary
					aria-controls="panel6-content"
					id="panel6-header"
				>
					<AccordionTitle
						title={'Other'}
					/>
				</AccordionSummary>
				<AccordionDetails>
					<Others/>
				</AccordionDetails>
			</Accordion>
		</Fragment>
	)
}

export default MuiComponents